export default __webpack_public_path__ + "static/media/how_merge_works_KADAP.90f6634e.pdf";